// import React, { useEffect, useState } from "react";
// import { Link, useLocation, useParams } from "react-router-dom";
// import { useFormik } from "formik";
// import * as yup from "yup";
// import voiceEvacuation from '../../../../../src/assets/images/voice-evacuation.png';
// import ASD from '../../../../../src/assets/images/ASD.png';
// import aerosol from '../../../../../src/assets/images/aerosol.png';
// import FireAlarm from '../../../../../src/assets/images/fire-alarm.png';
// import cleanagent from '../../../../../src/assets/images/clean-agent.png';
// import fireextinguisher from '../../../../../src/assets/images/fire-extinguisher.png';
// import firehosecabinet from '../../../../../src/assets/images/fire-hose-cabinet.png';
// import firewatertank from '../../../../../src/assets/images/fire-water-tank.png';
// import foamsystem from '../../../../../src/assets/images/foam-system.png';
// import kitchenhoodfs from '../../../../../src/assets/images/kitchen-hood.png';
// import standpipe from '../../../../../src/assets/images/standpipe.png';
// import firepump from '../../../../../src/assets/images/firepump.png';
// import firehydrant from '../../../../../src/assets/images/fire-hydrant.png';
// import fireprotect from '../../../../../src/assets/images/fireprotect.png';
// import defaulr from '../../../../../src/assets/images/defaulr.jpeg';
// import FormLayout from "../FormLayout";
// import { useToast } from "../../../../Components/Others/ToastServices";
// import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
// import UseCatSubCatDropDown from "../../../../Components/Hooks/useCategoryDropDown";
// import Pagination from "../../../../Components/Utils/Pagenation";
// import FormikSelectTwo from "../../../../Components/Utils/Select";
// import { CancelButton, SubmitButton } from "../../../../Components/Utils/Buttons";
// import ImportForms from "./ImportForms";
// import MultiEditForms from "./MultiEditForms";
// import ModalContainer from "../../../../Components/Others/ModalContainer";
// import CloseIcon from "../../../../Components/Icons/Close";
// import { NuDate } from "../../../../Components/Utils/Input";
// import axiosInstance from "../../../../Services/axiosCommon";
// import useFetchMDIndex from "../../../../Components/Hooks/useFetchMDIndex";
// import useFetchMataData from "../../../../Components/Hooks/useFetchMataData";

// const formImages = {
//   "Fire Protection System - Summary": fireprotect,
//   "Fire Pump": firepump,
//   "Fire Water Tanks": firewatertank,
//   "Fire / Foam Hose Cabinet": firehosecabinet,
//   "Fire / Foam Hose Cabinet Details": firehosecabinet,
//   "Fire Extinguisher": fireextinguisher,
//   "Fire Extinguisher Details": fireextinguisher,
//   "Clean Agent Fire Suppression System": cleanagent,
//   "Fire Alarm System": FireAlarm,
//   "Aspirating Smoke Detection System": ASD,
//   "Asd System": ASD,
//   "Voice Evacuation System /Pava": voiceEvacuation,
//   "Stand Pipe Hose System": standpipe,
//   "Foam Fire Suppression System": foamsystem,
//   "Fire Hydrant": firehydrant,
//   "Kitchen Hood Fire Suppression Sys.": kitchenhoodfs,
//   "Aerosol Fire Suppression System": aerosol,
// };

// // Using a simple document icon as default
// const defaultImage = defaulr;

// function FormsIndex() {
//   const { officeId } = useParams();

//   const [screenSize, setScreenSize] = useState({
//     width: window.innerWidth,
//   });

//   //  const { value: FormType} = useFetchMataData(
//   //   `/dropdown/dropdown-details/`,
//   //   "Form_Types"
//   // );

//   useEffect(() => {
//     const handleResize = () => {
//       setScreenSize({
//         width: window.innerWidth,
//       });
//     };

//     window.addEventListener("resize", handleResize);

//     return () => {
//       window.removeEventListener("resize", handleResize);
//     };
//   }, []);
//   const toast = useToast();
//   const location = useLocation();
//   const currentPage = location.state?.currentPage;
//   const searchQuery = location.state?.searchQuery;
//   const [page, setPage] = useState(currentPage || 1);
//   const [pageCount, setPageCount] = useState(
//     localStorage.getItem("perPageView") || 20
//   );
//   const [filter, setFilter] = useState(false);
//   const [showFilterDialog, setShowFilterDialog] = useState(false);
//   const { value: brand } = useFetchMDIndex(
//     `/dropdown/dropdown-details/`,
//     "brand_item",
//     showFilterDialog
//   );
//   const { value: Manufacture } = useFetchMDIndex(
//     `/dropdown/dropdown-details/`,
//     "Manufacture_item",
//     showFilterDialog
//   );
//   const { value: Unit } = useFetchMDIndex(
//     `/dropdown/dropdown-details/`,
//     "Unit_item",
//     showFilterDialog
//   );

//   const [formList, setFormList] = useState([]);
//   const [loading, setLoading] = useState(false);

//   const [filterProps, setFilterProps] = useState({
//     category: "",
//     subCategory: "",
//     brand: "",
//     manufacturer: "",
//     underPromotion: "",
//     unit: "",
//   });
//   const [params, setParams] = useState({
//     page: page,
//     per_page: pageCount,
//     search: searchQuery || "",
//     category: "",
//   });
//   const clearFilter = () => {
//     setParams({
//       ...params,
//       category: "",
//       subCategory: "",
//       brand: "",
//       manufacturer: "",
//       underPromotion: "",
//       unit: "",
//     });
//     formik.values.category = "";
//     formik.values.subCategory = "";
//     formik.values.brand = "";
//     formik.values.manufacturer = "";
//     formik.values.underPromotion = "";
//     formik.values.unit = "";

//     setFilter(false);
//   };

//   const formik = useFormik({
//     enableReinitialize: true,
//     initialValues: filterProps,
//     validateOnChange: false,
//     validateOnBlur: false,
//     validationSchema: yup.object({
//       // email: yup.string().required('Email is required!'),
//     }),
//     onSubmit: async (value, { resetForm }) => {
//       console.log("ffff", value);
//       setParams({
//         ...params,
//         category: value.category,
//         subCategory: value.subCategory,
//         brand: value.brand,
//         manufacturer: value.manufacturer,
//         underPromotion: value.underPromotion,
//         unit: value.unit,
//       });
//       closeFilterDialog();
//       setFilter(true);
//       setFilterProps({
//         category: "",
//         subCategory: "",
//         brand: "",
//         manufacturer: "",
//         underPromotion: "",
//         unit: "",
//       });
//     },
//   });

//   const { data, totalCount, getData, dataLoading,total } = UseGetDataSearch(
//     "/form/all-forms",
//    params
//   );


  
// //   const handleTabClick = (formTypeValue) => {
// //   setActiveTab(formTypeValue);
// //   setParams((prev) => ({
// //     ...prev,
// //     category: formTypeValue,
// //     page: 1 
// //   }));
// // };


// // useEffect(() => {
// //   const fetchForms = async () => {
// //     try {
// //       setLoading(true);
// //       const response = await axiosInstance.get("/form/all-forms", {
// //         params,
// //       });
// //       setFormList(response.data?.data || []);
// //     } catch (err) {
// //       console.error("Failed to fetch forms", err);
// //     } finally {
// //       setLoading(false);
// //     }
// //   };

// //   if (params.category) {
// //     fetchForms();
// //   }
// // }, [params]);

//   // const [allForm,setAllForm] = useState([])

//   // useEffect(() => {
//   //   fetchTasks();
//   // }, []);

//   // const fetchTasks = async () => {
//   //   try {
//   //     // setLoading(true);
//   //     const response = await axiosInstance.get(`/form/all-forms`);
//   //     console.log(response.data?.data);
//   //     setAllForm(response.data?.data);
//   //   } catch (error) {
//   //     console.error("Error fetching tasks:", error);
//   //   } finally {
//   //     // setLoading(false);
//   //   }
//   // };

//   const [showExport, setShowExport] = useState(false);
//   const [exportValue, setExportValue] = useState({
//     Client: "",
//     Project: "",
//     salesPerson: "",
//     Location: "",
//     Inspector: "",
//     InspectionDate: "",
//     Status: "",
//   });
//   const ExportFormik = useFormik({
//     enableReinitialize: true,
//     initialValues: exportValue,
//     validateOnChange: false,
//     validateOnBlur: false,
//     onSubmit: async (value, { resetForm }) => {
//       try {
//         const response = await axiosInstance.get(
//           `/customer-quotations/export-to-excel?approvalStatus=${value.approvalStatus}&salesPerson=${value.salesPerson}&status=${value.status}&leadTime=${value.leadTime}&validity=${value.validity}&availability=${value.availability}&paymentMethod=${value.paymentMethod}&paymentTerms=${value.paymentTerms}&deliveryTerms=${value.deliveryTerms}&fromDate=${value.fromDate}&toDate=${value.toDate}`,
//           {
//             responseType: "blob",
//           }
//         );

//         const pdfBlob = new Blob([response.data], {
//           type: "application/vnd.openxmlformats-officedocument.spreadsheetml.sheet",
//         });

//         const link = document.createElement("a");
//         link.href = window.URL.createObjectURL(pdfBlob);
//         link.download = `CQ Report ${NuDate({
//           value: new Date(),
//           format: "DD-MMM-YYYY",
//         })}.xlsx`;

//         document.body.appendChild(link);
//         link.click();

//         link.parentNode.removeChild(link);
//       } catch (error) {
//         console.error("Error downloading the PDF:", error);
//       }
//     },
//   });
//   const closeFilterDialogebox = () => {
//     setShowExport(false);
//   };

//   useEffect(() => {
//     setParams({ ...params, page: page, per_page: pageCount });
//   }, [page, pageCount]);

//   const closeFilterDialog = () => {
//     setShowFilterDialog(false);
//   };
//   const { category: itemsCategory, subCategory: itemsSubCategory } =
//     UseCatSubCatDropDown(
//       "/category/ItemCategory",
//       "ItemCategory",
//       formik?.values?.category
//     );
//   const [showImportModal, setShowImportModal] = useState(false);

//   const handleImportClick = () => {
//     setShowImportModal(true);
//   };

//   const handleExportClick = () => {
//     setShowExport(true);
//   };

//   const closeModal = () => {
//     setShowImportModal(false);
//   };

//   const [showEdit, setShowEdit] = useState(false);
//   const [showDelete, setShowDelete] = useState(false);
//   const [listofNumbers, setListofNumbers] = useState([]);
//   const [fullList, setFullList] = useState([]);

//   const selectOneFunction = (value) => {
//     let NewId;
//     if (listofNumbers && listofNumbers.some((Item) => Item === value)) {
//       NewId = listofNumbers.filter((Temp) => Temp !== value);
//       setListofNumbers(NewId);
//     } else {
//       setListofNumbers([...listofNumbers, value]);
//     }
//   };

//   const selectMultipleFunction = (e) => {
//     console.log(e.target.checked);
//     if (e.target.checked) {
//       setListofNumbers(fullList);
//     } else {
//       setListofNumbers([]);
//     }
//   };

//   const handleMultiDelete = (data) => {
//     axiosInstance
//       .delete(`items/multi-delete`, {
//         headers: {
//           "Content-Type": "application/json",
//         },
//         data: { ids: data },
//       })
//       .then((res) => {
//         if (res.data?.status === true) {
//           if (res?.data?.not_deleted_ids.length <= 0) {
//             toast.open({
//               type: "success",
//               message: "Success",
//               description: res.data?.msg || "Deleted Successfully.",
//             });
//             getData();
//             setShowDelete(false);
//           } else {
//             toast.open({
//               type: "warning",
//               message: "Success",
//               description:
//                 `${res.data?.msg} \n Some Products has dependenies` ||
//                 "Deleted Successfully.",
//             });
//             getData();
//             setShowDelete(false);
//           }
//         } else if (res.data?.status === false && res.data?.error) {
//           toast.open({
//             type: "error",
//             message: "Error",
//             description: res.data.error || "Delete UnSuccessfull",
//           });
//         } else {
//           toast.open({
//             type: "warning",
//             message: "Warning",
//             description: res.data?.msg || "Warning.",
//           });
//         }
//       })
//       .catch((err) => {
//         console.error(err);
//         toast.open({
//           type: "error",
//           message: "Error",
//           description: "Network Error.",
//         });
//       });
//   };

//   console.log("Data", data);
  


//   // useEffect(() => {
//   //   let tempArr = [];
//   //   data &&
//   //     data.forEach((i) => {
//   //       console.log("I", i?.formId);
//   //       tempArr.push(i?.formId);
//   //     });
//   //   setFullList(tempArr);
//   // }, [data]);

//  const [FormType, setFormType] = useState([]);

// useEffect(() => {
//   axiosInstance
//     .get("/survey-category/")
//     .then((res) => {
//       setFormType(res.data.data || []);
//     })
//     .catch((err) => {
//       console.error("API error:", err);
//     });
// }, []);




//    const [valueOfSearch,setValuesofSearch] = useState("")
//      function searchFunction(e) {
   
       
//        setValuesofSearch(e?.target?.value)
//        setParams({ ...params, search: e?.target?.value, page:1 });
//        setPage(1)
//      }
     
// const [activeTab, setActiveTab] = useState("");

// //  const handleTabClick = (formTypeValue) => {
// //   setActiveTab(formTypeValue);
// //   setParams((prev) => ({
// //     ...prev,
// //     category: formTypeValue,
// //     page: 1 
// //   }));
// // };


// const handleTabClick = (id) => {
//   setActiveTab(id);
// };


// useEffect(() => {
//   if (FormType?.length > 0 && !activeTab) {
//     const defaultType = FormType[0].value;
//     setActiveTab(defaultType);
//     setParams((prev) => ({ ...prev, category: defaultType }));
//   }
// }, [FormType]);




//   return (
//     <>
//     <FormLayout
//             searchFun={searchFunction}
//             searchValue={valueOfSearch}
//                   total={totalCount}

//     >
//     <div className="w-full h-full  mt-0.5 ">
     
//       <div className=" w-full h-[calc(100vh-180px)] bg-white  rounded-md overflow-hidden px-4 py-2">
        

   




//         <div className=" w-full h-[calc(100vh-235px)] ">
// <div className="flex flex-wrap">
//   {FormType?.filter(form => form.enabled).map((form) => (
//     <button
//       key={form.id}
//       onClick={() => handleTabClick(form.id)}
//       className={`mx-3 mb-2 pb-1 text-xs 2xl:text-sm font-medium ${
//         activeTab === form.id
//           ? "text-baseColor-primary underline underline-offset-4 decoration-2"
//           : "text-gray-500"
//       }`}
//     >
//       {form.category}
//     </button>
//   ))}
// </div>


//           {/* <div className="flex flex-wrap">
//           {FormType?.map((form) => (
//             <button
//               key={form.value}
//               onClick={() => handleTabClick(form.value)}
//               className={`mx-3 mb-2 pb-1 text-xs 2xl:text-sm font-medium ${
//                 activeTab === form.value
//                   ? "text-baseColor-primary underline underline-offset-4 decoration-2"
//                   : "text-gray-500"
//               }`}
//             >
//               {form.label} 
//             </button>
//           ))}
//         </div> */}
//         <div className="w-full max-h-[calc(100vh-235px)] grid grid-cols-2 md:grid-cols-5 lg:grid-cols-7 gap-4 overflow-y-auto py-4">
//   {data &&
//     data.map((item, i) => {
//       return (
//         <Link
//           key={i}
//           to={`/forms/surveyforms/view/${item?.id}`}
//           state={{ data: item }}
//           className="relative w-full h-auto bg-white text-[#111537] rounded-lg shadow-lg"
//         >
//           {/* Serial Number Top-Left */}
//           <div className="h-[30px] w-full">
//           <span className="absolute top-1 left-2 text-xs  text-gray-500 border border-pageborder rounded-md p-1 w-5 h-5 flex items-center justify-center">
//             {i + 1}
//           </span>
// </div>
//           <div className="w-full h-auto flex flex-col py-1 px-2 justify-between items-center">
//             <img 
//                       src={formImages[item.formName] || defaultImage} 
//                       alt={item.formName}
//                       className="w-16 h-16 object-contain"
//                       onError={(e) => {
//                         e.target.src = defaultImage;
//                       }}
//                     />
//             <p className="line-clamp-3 text-xs text-center">
//               {item?.formName || ""}
//             </p>
//           </div>
//         </Link>
//       );
//     })}
// </div>

//         </div>
//         <div className=" w-full h-[40px] pb-4 bg-white">
//           <Pagination
//             page={page}
//             setPage={setPage}
//             totalCount={totalCount}
//             pageCount={pageCount}
//             setPageCount={setPageCount}
//           />
//         </div>
//       </div>
    
    

    
//     </div>
//     </FormLayout></>
//   );
// }

// export default FormsIndex;


import React, { useEffect, useState } from "react";
import { useLocation } from "react-router-dom";
import FormLayout from "../FormLayout";
import { useToast } from "../../../../Components/Others/ToastServices";
import UseGetDataSearch from "../../../../Components/Hooks/useFetchDataBySearch";
import Pagination from "../../../../Components/Utils/Pagenation";
import axiosInstance from "../../../../Services/axiosCommon";
import SignatureCanvas from "react-signature-canvas";
import Attachement from "../../../../Components/Utils/CustomAttrachmentupload";
import { NuFormSelect, NuInput, NuInputfile, NuTableFormSelect, NuTextArea } from "../../../../Components/Utils/Input";


function FormsIndex() {
  const toast = useToast();
  const location = useLocation();
  
  const [screenSize, setScreenSize] = useState({
    width: window.innerWidth,
  });
  const [page, setPage] = useState(1);
  const [pageCount, setPageCount] = useState(
    localStorage.getItem("perPageView") || 20
  );

  const [fullList, setFullList] = useState([]);
  const [FormType, setFormType] = useState([]);
  const [valueOfSearch, setValuesofSearch] = useState("");
  const [activeTab, setActiveTab] = useState("");
  const [image, setImage] = useState(null);
  const [files, setFiles] = useState([]);

   const collectorSigCanvas = React.createRef();
  const clientSigCanvas = React.createRef();

  const [params, setParams] = useState({
    page: page,
    per_page: pageCount,
    search: "",
    category: 3,
  });

   useEffect(() => {
    const currentPage = location.state?.currentPage;
    const searchQuery = location.state?.searchQuery;
    
    if (currentPage) setPage(currentPage);
    if (searchQuery) {
      setValuesofSearch(searchQuery);
      setParams(prev => ({
        ...prev,
        search: searchQuery
      }));
    }
  }, [location.state]);

   useEffect(() => {
    const handleResize = () => {
      setScreenSize({
        width: window.innerWidth,
      });
    };

    window.addEventListener("resize", handleResize);
    return () => window.removeEventListener("resize", handleResize);
  }, []);

   useEffect(() => {
    axiosInstance.get("/survey-category/")
      .then((res) => {
        const enabledForms = res.data.data?.filter(form => form.enabled) || [];
        setFormType(enabledForms);
        
          if (enabledForms.length > 0 && !activeTab) {
          setActiveTab(enabledForms[0].id);
          setParams(prev => ({
            ...prev,
            category: enabledForms[0].id
          }));
        }
      })
      .catch(console.error);
  }, []);

   useEffect(() => {
    setParams(prev => ({
      ...prev,
      page: page,
      per_page: pageCount
    }));
  }, [page, pageCount]);

 const handleTabClick = (id) => {
  setActiveTab(id);
  setPage(1); 
  setParams(prev => ({
    ...prev,
    category: id,
    page: 1
  }));

  if (id === 1) {
    getForm(); 
  } else {
    setForm(null); 
  }
};


   const searchFunction = (e) => {
    const value = e?.target?.value;
    setValuesofSearch(value);
    setPage(1); 
    setParams(prev => ({
      ...prev,
      search: value,
      page: 1
    }));
  };

    const { data, totalCount, getData, dataLoading, total } = UseGetDataSearch(
    "/form/all-forms",
    params
  );

    useEffect(() => {
    if (data) {
      setFullList(data.map(item => item.id));
    }
  }, [data]);
  const [NewForm, setForm] = useState(null);

function getForm() {
  axiosInstance
    .get(`/surveyInspectionForm/get-form`)
    .then((res) => {
      if (res.data?.data) {
        setForm(res.data.data);
      } else {
        console.error("Unexpected API response format");
        setForm(null);
      }
    })
    .catch((err) => {
      console.error("Error fetching forms:", err);
      setForm(null);
    });
}






   const clearSignature = (type) => {
    if (type === "collector" && collectorSigCanvas.current) {
      collectorSigCanvas.current.clear();
    } else if (type === "client" && clientSigCanvas.current) {
      clientSigCanvas.current.clear();
    }
  };

  const saveSignature = (type) => {
    if (type === "collector" && collectorSigCanvas.current) {
      const signature = collectorSigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
        } else if (type === "client" && clientSigCanvas.current) {
      const signature = clientSigCanvas.current.getTrimmedCanvas().toDataURL('image/png');
     }
  };

   const handleImageChange = (e) => {
    const selectedFiles = Array.from(e.target.files);
    const filesArray = selectedFiles.map(file => ({
      file,
      preview: URL.createObjectURL(file)
    }));
    setFiles(filesArray);
  };

  const removeImages = (index) => {
    const newFiles = [...files];
    URL.revokeObjectURL(newFiles[index].preview);
    newFiles.splice(index, 1);
    setFiles(newFiles);
  };

   function giveValue(value, formik) {
    switch (value?.field_type) {
      case "text":
        return (
          <>
            <div className={`w-full py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label || "  "}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "number":
        return (
          <>
            <div className={`w-full py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5 text-right">
                    <p>{value?.field_label || "  "}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "string":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs  mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.Name}</p>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "yesno":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  {[
                    { label: "Yes", type: "checkbox" },
                    { label: "No", type: "checkbox" },
                    { label: "N/A", type: "checkbox" },
                  ] &&
                    [
                      { label: "Yes", type: "checkbox" },
                      { label: "No", type: "checkbox" },
                      { label: "N/A", type: "checkbox" },
                    ].map((item, k) => {
                      return (
                        <td key={k}>
                          <div className="flex justify-center items-center gap-2">
                            <p>{item?.label || ""}</p>
                            <input type="checkbox" />
                          </div>
                        </td>
                      );
                    })}
                </tr>
              </table>
            </div>
          </>
        );
      case "checkbox":
        return (
          <>
            <div className="w-full py-2 text-xs mt-5">
              <table className="w-full">
                <tbody>
                  <tr>
                    <td className="w-2/12 align-top">
                      <p>{value?.field_label}</p>
                    </td>

                    <td className="w-10/12 p-0">
                      <table className="w-full">
                        <tbody>
                          {Array.from({
                            length: Math.ceil(
                              Object.entries(value?.metadata).length / 5
                            ),
                          }).map((_, rowIndex) => {
                            const items = Object.entries(value?.metadata).slice(
                              rowIndex * 5,
                              rowIndex * 5 + 5
                            );
                            const emptyCells = 5 - items.length;

                            return (
                              <tr key={rowIndex}>
                                {Array.from({ length: emptyCells }).map(
                                  (_, i) => (
                                    <td
                                      key={`empty-${i}`}
                                      className="w-1/6 p-2"
                                    ></td>
                                  )
                                )}

                                {value?.metadata &&
                                  Object.entries(value?.metadata).map(
                                    ([key, valueOf]) => (
                                      <td key={valueOf}>
                                        <div className="flex justify-end items-center gap-2 w-[200px]">
                                          <p>{key || ""}</p>
                                          <input type="checkbox" />
                                        </div>
                                      </td>
                                    )
                                  )}
                              </tr>
                            );
                          })}
                        </tbody>
                      </table>
                    </td>
                  </tr>
                </tbody>
              </table>
            </div>
          </>
        );
      case "single_checkbox":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-2/12">
                    <p>{value?.field_label}</p>
                  </td>
                  {value?.metadata &&
                    Object.entries(value?.metadata).map(
                      ([key, valueOf], idxOne) => (
                        <td key={idxOne} className=" w-1/12 p-2 ">
                          <div className="flex flex-row-reverse justify-start items-center gap-2">
                            <input type="checkbox" />
                            <p>{key || ""}</p>
                          </div>
                        </td>
                      )
                    )}
                </tr>
              </table>
            </div>
          </>
        );
      case "textArea":
        return (
          <>
            <NuTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
            />
          </>
        );
      case "observation":
        return (
          <>
            <NuTextArea
              label=""
              placeholder={value?.field_label || ""}
              formik={formik}
              name={value?.field_label}
              new_width={"w-full"}
            />
          </>
        );
      case "date":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs w-full  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "time":
        return (
          <>
            <div className={` ${value?.width} py-2 text-xs  `}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.Name}</p>
                  </td>
                  <td className="w-2/5">
                    <NuInput
                      label={""}
                      type={value?.type}
                      formik={formik}
                      placeholder={value?.Name}
                      name={value?.value}
                      width={"w-full"}
                    />
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "imagePath":
        return (
          <>
            <NuInputfile
              label={""}
              name={value?.field_label}
              handleChange={() => {}}
              width={"w-full"}
              placeholder="file upload"
            />
          </>
        );
      case "file":
        return (
          <>
            <NuInputfile
              label={""}
              name={value?.field_label}
              handleChange={() => {}}
              width={"w-full"}
              placeholder="file upload"
            />
          </>
        );
      case "table-data":
        return (
          <>
            <div className=" w-full">
              <table className=" w-full  text-xs">
                <thead>
                  <tr>
                    {value?.value &&
                      value?.value.map((item, k) => {
                        return (
                          <th key={k} className="text-left py-2 px-4 ">
                            {item?.label || ""}
                          </th>
                        );
                      })}
                  </tr>
                </thead>
                <tbody>
                  {Array(10)
                    .fill(0)
                    .map((_, i) => (
                      <tr key={i}>
                        {value?.value &&
                          value?.value.map((item, k) => {
                            return (
                              <td
                                key={k}
                                className="text-left py-2 px-4  h-8 border"
                              >
                                {""}
                              </td>
                            );
                          })}
                      </tr>
                    ))}
                </tbody>
              </table>
            </div>
          </>
        );
      case "multi":
        return (
          <>
            <div className=" w-full">
              {value?.metadata && Object.keys(value?.metadata).length > 3 ? (
                <div className="grid grid-cols-4 gap-2 items-center text-xs  ">
                  <div>{value?.field_label || ""}</div>
                  {Object.entries(value?.metadata).map(([key, valueOf], i) => {
                    return (
                      <>
                        {key == "Comments" ? (
                          <div
                            className=" col-span-3 grid grid-cols-3  "
                            key={i}
                          >
                            <div></div>
                            <div className=" col-span-2 flex items-center justify-end ">
                              <p className="  ">{key || ""}</p>
                              <textarea
                                className="w-5/6 border outline-none border-gray-300 rounded-lg px-3 py-2 my-3"
                                rows={3}
                                label=""
                                placeholder={""}
                                formik={formik}
                                name={value?.field_label}
                                new_width={"w-1/4"}
                              />
                            </div>
                          </div>
                        ) : (
                          <>
                            {valueOf == "text" ? (
                              <div
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " w-full"
                                    : " w-full"
                                } flex gap-3 items-center ${
                                  (i + 1) % 5 !== 1 ? "text-end" : "text-start "
                                } ${i + 1 === 1 ? "text-end" : ""}  ${
                                  (i + 1) % 4 === 0 && i + 1 !== 1
                                    ? " col-span-2 "
                                    : ""
                                }`}
                                key={i}
                              >
                                {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                  <>
                                    <div className=" w-full flex justify-end items-center gap-2">
                                      <div className=" w-1/2"></div>
                                      <div className=" w-1/2 flex gap-1 items-center">
                                        <p className=" w-1/3 text-xs mr-1.5">
                                          {key || ""}
                                        </p>
                                        <input
                                          label={""}
                                          type={value?.type}
                                          formik={formik}
                                          placeholder={value?.Name}
                                          name={value?.value}
                                          width={"w-full"}
                                          className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                        />
                                      </div>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p className=" w-1/3 text-xs text-right ">
                                      {key || ""}
                                    </p>
                                    <input
                                      label={""}
                                      type={value?.type}
                                      formik={formik}
                                      placeholder={value?.Name}
                                      name={value?.value}
                                      width={"w-full"}
                                      className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                    />
                                  </>
                                )}
                              </div>
                            ) : valueOf == "string" ? (
                              <div className=" w-full text-xs ">
                                <p className=" w-full">{key || ""}</p>
                              </div>
                            ) : valueOf == "yesno" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-3/5 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      {[
                                        {
                                          label: "Yes",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "No",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "N/A",
                                          type: "checkbox",
                                        },
                                      ] &&
                                        [
                                          {
                                            label: "Yes",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "No",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "N/A",
                                            type: "checkbox",
                                          },
                                        ].map((item, k) => {
                                          return (
                                            <td key={k} className=" px-1.5">
                                              <div className="flex justify-center items-center gap-0.5 text-end ">
                                                <p>{item?.label || ""}</p>
                                                <input type="checkbox" />
                                              </div>
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : valueOf == "number" ? (
                              <>
                                <div
                                  className={`${
                                    Object.keys(value?.metadata).length >= 3
                                      ? " w-full"
                                      : " w-full"
                                  } flex gap-3 items-center ${
                                    (i + 1) % 5 !== 1
                                      ? "text-end"
                                      : "text-start "
                                  } ${i + 1 === 1 ? "text-end" : ""}  ${
                                    (i + 1) % 4 === 0 && i + 1 !== 1
                                      ? " col-span-2 "
                                      : ""
                                  }`}
                                >
                                  {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                    <>
                                      <div className=" w-full flex justify-end items-center gap-2">
                                        <div className=" w-1/2"></div>
                                        <div className=" w-1/2 flex gap-1 items-center">
                                          <p className=" w-1/3 text-xs">
                                            {key || ""}
                                          </p>
                                          <input
                                            label={""}
                                            type={value?.type}
                                            formik={formik}
                                            placeholder={value?.Name}
                                            name={value?.value}
                                            width={"w-full"}
                                            className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                          />
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <p className=" w-1/3 text-xs text-right">
                                        {key || ""}
                                      </p>
                                      <input
                                        label={""}
                                        type={value?.type}
                                        formik={formik}
                                        placeholder={value?.Name}
                                        name={value?.value}
                                        width={"w-full"}
                                        className=" w-full border outline-none border-gray-300 rounded-lg px-3 py-2"
                                      />
                                    </>
                                  )}
                                </div>
                              </>
                            ) : valueOf == "checkbox" ? (
                              <>
                                <div
                                  className={`${
                                    Object.keys(value?.metadata).length >= 3
                                      ? " w-full"
                                      : " w-full"
                                  } flex gap-3 items-center ${
                                    (i + 1) % 5 !== 1
                                      ? "text-end"
                                      : "text-start "
                                  } ${i + 1 === 1 ? "text-end" : ""}  ${
                                    (i + 1) % 4 === 0 && i + 1 !== 1
                                      ? " col-span-2 "
                                      : ""
                                  }`}
                                >
                                  {(i + 1) % 4 === 0 && i + 1 !== 1 ? (
                                    <>
                                      <div className=" w-full flex justify-end items-center gap-2">
                                        <div className=" w-1/2"></div>
                                        <div className=" w-1/2 flex gap-1 items-center">
                                          <p className=" w-1/3 text-xs">
                                            {key || ""}
                                          </p>
                                          <input type="checkbox" />
                                        </div>
                                      </div>
                                    </>
                                  ) : (
                                    <>
                                      <p className=" w-1/3 text-xs">
                                        {key || ""}
                                      </p>
                                      <input type="checkbox" />
                                    </>
                                  )}
                                </div>
                              </>
                            ) : valueOf == "truefalse" ? (
                              <>
                                <div className=" w-full flex justify-end items-center gap-2">
                                  <p className=" w-1/3  text-xs text-right">
                                    {key || ""}
                                  </p>
                                  <input type="checkbox" />
                                </div>
                              </>
                            ) : valueOf == "yesnona" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-3/5 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      {[
                                        {
                                          label: "Yes",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "No",
                                          type: "checkbox",
                                        },
                                        {
                                          label: "N/A",
                                          type: "checkbox",
                                        },
                                      ] &&
                                        [
                                          {
                                            label: "Yes",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "No",
                                            type: "checkbox",
                                          },
                                          {
                                            label: "N/A",
                                            type: "checkbox",
                                          },
                                        ].map((item, k) => {
                                          return (
                                            <td key={k} className=" px-1.5">
                                              <div className="flex justify-center items-center gap-0.5 text-end ">
                                                <p>{item?.label || ""}</p>
                                                <input type="checkbox" />
                                              </div>
                                            </td>
                                          );
                                        })}
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : valueOf == "dropdown" ? (
                              <>
                                <div className={`w-full py-2 text-xs  `}>
                                  <table className="w-full">
                                    <tr>
                                      <td className="w-5/12 text-end px-2">
                                        <p>{key}</p>
                                      </td>
                                      <td className="px-2">
                                        <NuFormSelect
                                          name={key}
                                          label={key}
                                          placeholder={""}
                                          id={value?.id}
                                          field_type={value?.field_type}
                                          allValue={[]}
                                          setAllValue={() => {}}
                                          disabled={false}
                                          options={[]}
                                        />
                                      </td>
                                    </tr>
                                  </table>
                                </div>
                              </>
                            ) : (
                              <div className="w-full text-xs ">
                                <p className="">{key || ""}</p>
                              </div>
                            )}
                          </>
                        )}
                      </>
                    );
                  })}
                </div>
              ) : (
                <>
                  <table className="w-full  ">
                    <tr>
                      {value?.metadata &&
                        Object.entries(value?.metadata).map(
                          ([key, valueOf], idxTwo) => (
                            <>
                              <td
                                key={idxTwo}
                                className=" text-xs  text-end first:text-start"
                              >
                                {valueOf == "text" ? (
                                  <div
                                    className={`w-full flex gap-3 items-center `}
                                  >
                                    <p className=" w-1/2 text-xs">
                                      {key || ""}
                                    </p>
                                    <NuInput
                                      label={""}
                                      type={value?.type}
                                      formik={formik}
                                      placeholder={value?.Name}
                                      name={value?.value}
                                      width={"w-full"}
                                    />
                                  </div>
                                ) : valueOf == "number" ? (
                                  <div
                                    className={`w-full flex gap-3 items-center `}
                                  >
                                    <p className=" w-1/2 text-xs">
                                      {key || ""}
                                    </p>
                                    <NuInput
                                      label={""}
                                      type={value?.type}
                                      formik={formik}
                                      placeholder={value?.Name}
                                      name={value?.value}
                                      width={"w-full"}
                                    />
                                  </div>
                                ) : valueOf == "string" ? (
                                  <>
                                    <p>{key || ""}</p>
                                  </>
                                ) : valueOf == "yesnona" ? (
                                  <>
                                    <div className={`w-full py-2 text-xs  `}>
                                      <table className="w-full">
                                        <tr>
                                          <td className="w-3/5 text-end px-2">
                                            <p>{key}</p>
                                          </td>

                                          {[
                                            { label: "Yes", type: "checkbox" },
                                            { label: "No", type: "checkbox" },
                                            { label: "N/A", type: "checkbox" },
                                          ] &&
                                            [
                                              {
                                                label: "Yes",
                                                type: "checkbox",
                                              },
                                              { label: "No", type: "checkbox" },
                                              {
                                                label: "N/A",
                                                type: "checkbox",
                                              },
                                            ].map((item, k) => {
                                              return <input type="checkbox" />;
                                            })}
                                        </tr>
                                      </table>
                                    </div>
                                  </>
                                ) : valueOf == "yesno" ? (
                                  <>
                                    <div className={`w-full py-2 text-xs  `}>
                                      <table className="w-full">
                                        <tr>
                                          <td className="w-3/5 text-end px-2">
                                            <p>{key}</p>
                                          </td>

                                          {[
                                            { label: "Yes", type: "checkbox" },
                                            { label: "No", type: "checkbox" },
                                            { label: "N/A", type: "checkbox" },
                                          ] &&
                                            [
                                              {
                                                label: "Yes",
                                                type: "checkbox",
                                              },
                                              { label: "No", type: "checkbox" },
                                              {
                                                label: "N/A",
                                                type: "checkbox",
                                              },
                                            ].map((item, k) => {
                                              return <input type="checkbox" />;
                                            })}
                                        </tr>
                                      </table>
                                    </div>
                                  </>
                                ) : (
                                  <>
                                    <p>{`${key} ${valueOf}` || ""}</p>
                                  </>
                                )}
                              </td>
                            </>
                          )
                        )}
                    </tr>
                  </table>
                </>
              )}
            </div>
          </>
        );
      case "tableRow":
        return (
          <>
            <table className="w-full border border-collapse">
              <tr>
                {/* <td className="w-2/12 text-xs border px-2">
                    <p>{value?.field_label}</p>
                </td> */}
                {
                  <>
                    {Object.entries(value?.metadata).map(
                      ([key, valueOf], idxThree) => {
                        return (
                          <>
                            {valueOf == "text" ? (
                              <td
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " "
                                    : "   "
                                }text-xs border-y px-3`}
                                key={idxThree}
                              >
                                {/* <p className=" w-1/2">{key || ""}</p> */}
                                <NuInput
                                  label={""}
                                  type={value?.type}
                                  formik={formik}
                                  placeholder={value?.Name}
                                  name={value?.value}
                                  width={"w-full"}
                                />
                              </td>
                            ) : valueOf == "date" ? (
                              <td
                                className={`${
                                  Object.keys(value?.metadata).length >= 3
                                    ? " "
                                    : "   "
                                }text-xs border px-3`}
                              >
                                {/* <p className=" w-1/2">{key || ""}</p> */}
                                <NuInput
                                  label={""}
                                  type={value?.type}
                                  formik={formik}
                                  placeholder={value?.Name}
                                  name={value?.value}
                                  width={"w-full"}
                                />
                              </td>
                            ) : value == "string" ? (
                              <td className=" w-full">
                                <p className=" w-full">{key || ""}</p>
                              </td>
                            ) : (
                              <td className="w-full">
                                <p className="">{`${key} ` || ""}</p>
                              </td>
                            )}
                          </>
                        );
                      }
                    )}
                  </>
                }
              </tr>
            </table>
          </>
        );
      case "tableItems":
        return (
          <>
          {
            value?.field_label == "items" ?(
              <div className=" w-full">
                {
                  Array.isArray(value?.metadata) && value?.metadata.length > 0 ? (
                    <>
                     {value?.metadata.map((item, indx) => (
                       <div key={indx} className=" w-full text-xs grid grid-cols-3 2xl:grid-cols-4 gap-4 items-center border-b py-3">
                         {
                          Object.entries(item).map(([key, valueOf], idx) => (
                            <div key={idx} className={`${valueOf == "textArea" ? "col-span-2":""} flex gap-2 items-center`} >
                              <p className={`${valueOf == "textArea" ? "w-2/12":" w-2/5"}`}>{`${key}` || ""}</p>
                              <p>:</p>
                              <div className={`${valueOf == "textArea" ? "w-10/12 pl-5":" w-3/5"}`}>
                              {valueOf == "text" ? (
                          <>
                          <input  type="text" className="border px-2 py-2.5 w-full rounded-lg" />
                          </>
                        ) : valueOf == "number" ? (
                          <>
                          <input  type="number" className="border px-2 py-2.5 w-full rounded-lg" />
                          </>
                        ) : valueOf == "legends" ? (
                          <>
                            <NuTableFormSelect
                              label={key}
                              type={"text"}
                              formik={formik}
                              placeholder={value?.Name}
                              name={`${key}${valueOf}${indx}`}
                              width={"w-full"}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={[]}
                              setAllValue={() => {}}
                              disabled={false}
                              idx={indx + 1}
                              options={[
                                {
                                  label: "Good",
                                  value: "Good",
                                },
                                {
                                  label: "Defective",
                                  value: "Defective",
                                },
                                {
                                  label: "Missing",
                                  value: "Missing",
                                },
                                {
                                  label: "N/A",
                                  value: "N/A",
                                },
                              ]}
                            />
                          </>
                        ) : valueOf == "textArea" ? (
                          <>
                          <textarea className="border px-2 py-3.5 w-full rounded-lg"></textarea>
                          </>
                        ) : (
                          <>
                            <p>{key || ""}</p>
                          </>
                        )}
                              </div>
                            </div>
                          ))}
                       </div>
                     ))}
                    </>
                  ) :(<p>No Data</p>)
                }
              </div>
            ):(
            <table className="w-full border border-collapse  text-xs">

              {Array.isArray(value?.metadata) && value?.metadata.length > 0 ? (
                value?.metadata.map((item, indx) => (
                  <tr key={indx} className=" text-xs">
                    {/* <td className=" w-2/12 border">{value?.label||"-"}</td> */}
                    {Object.entries(item).map(([key, valueOf], idx) => (
                      <td key={idx} className="border py-1 px-2 min-w-[50px] max-w-[250px]">
                        {valueOf == "text" ? (
                          <>
                          <input type="text" className="border px-2 py-2.5 w-full rounded-lg" />
                          </>
                        ) : valueOf == "number" ? (
                          <>
                            <NuInput
                              label={""}
                              type={value?.type}
                              formik={formik}
                              placeholder={value?.Name}
                              name={value?.value}
                              width={"w-full"}
                            />
                          </>
                        ) : valueOf == "legends" ? (
                          <>
                            <NuTableFormSelect
                              label={key}
                              type={"text"}
                              formik={formik}
                              placeholder={value?.Name}
                              name={`${key}${valueOf}${indx}`}
                              width={"w-full"}
                              id={value?.id}
                              field_type={value?.field_type}
                              allValue={[]}
                              setAllValue={() => {}}
                              disabled={false}
                              idx={indx + 1}
                              options={[
                                {
                                  label: "c",
                                  value: "C",
                                },
                                {
                                  label: "t",
                                  value: "t",
                                },
                                {
                                  label: "o",
                                  value: "o",
                                },
                                {
                                  label: "N",
                                  value: "N",
                                },
                              ]}
                            />
                          </>
                        ) : valueOf == "textArea" ? (
                          <>
                            <NuInput
                              label={""}
                              type={"text"}
                              formik={formik}
                              placeholder={value?.Name}
                              name={value?.value}
                              width={"w-full"}
                            />
                          </>
                        ) : (
                          <>
                            <p>{key || ""}</p>
                          </>
                        )}
                      </td>
                    ))}
                  </tr>
                ))
              ) : (
                <td>
                  <p>No Data</p>
                </td>
              )}

              {/* <tr>
                  <td className="w-2/12">
                    <p>{value?.field_label||""}</p>
                  </td>
  
               </tr> */}
            </table>
            )
          }
          </>
        );
      case "yesnona":
        return (
          <>
            <div className={`w-full py-2 text-xs   mt-5`}>
              <table className="w-full">
                <tr>
                  <td className="w-3/5">
                    <p>{value?.field_label}</p>
                  </td>
                  {[
                    { label: "Yes", type: "checkbox" },
                    { label: "No", type: "checkbox" },
                    { label: "N/A", type: "checkbox" },
                  ] &&
                    [
                      { label: "Yes", type: "checkbox" },
                      { label: "No", type: "checkbox" },
                      { label: "N/A", type: "checkbox" },
                    ].map((item, k) => {
                      return (
                        <td key={k}>
                          <div className="flex justify-center items-center gap-2">
                            <p>{item?.label || ""}</p>
                            <input type="checkbox" />
                          </div>
                        </td>
                      );
                    })}
                </tr>
              </table>
            </div>
          </>
        );
      case "heading":
        return (
          <>
            <div className={` w-full py-2 text-xs  mt-5 `}>
              <table className="w-full">
                <tr>
                  <td className="w-full">
                    <p>{value?.field_label}</p>
                  </td>
                </tr>
              </table>
            </div>
          </>
        );
      case "tableHeaders":
        return (
          <table className="w-full text-xs">
            <thead>
              {
                (value?.field_label == "FIRE EXTINGUISHER DETAILS" || value?.field_label == "FIRE / FOAM HOSE CABINET") ? (
                // <tr>
                //   <th className=" text-left p-2">Legends :</th>
                //   <th className=" text-left p-2">Good </th>
                //   <th className=" text-left p-2">Defective </th>
                //   <th className=" text-left p-2">Missing </th>
                //   <th className=" text-left p-2">N/A </th>
                // </tr>
                <p></p>
              ) :(
                <tr>
                {Object.entries(value?.metadata).length > 10 ? (
                  <>
                    {Object.entries(value?.metadata).map(
                      ([key, valueOf], idx) => (
                        <th
                          className=" [writing-mode:vertical-lr] max-h-[150px] rotate-180 p-2 text-left min-w-[50px] max-w-[250px] py-2 text-xs border "
                          key={idx}
                        >
                          {key}
                        </th>
                      )
                    )}
                  </>
                ) : (
                  <>
                    {Object.entries(value?.metadata).map(
                      ([key, valueOf], idx) => (
                        <th
                          className=" min-w-[150px] max-w-[250px] py-2 text-xs border "
                          key={idx}
                        >
                          {key}
                        </th>
                      )
                    )}
                  </>
                )}
              </tr>
                )
              }

            </thead>
          </table>
        );
      default:
        return <>No</>;
    }
  }

  const renderSignatureAndAttachments = () => (
    <div className="w-full  p-6">
      <h2 className="text-xl font-semibold text-gray-800 mb-6">Signature </h2>
      <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
       

        {/* Collector Signature */}
        <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
          {/* <h3 className="text-sm font-semibold text-gray-600 mb-2">Collector </h3> */}
          <SignatureCanvas
            penColor="black"
            canvasProps={{
              className: "border border-gray-400 w-full h-40 rounded-md",
            }}
            ref={collectorSigCanvas}
          />
          <div className="flex justify-between items-center mt-3">
            <span className="text-xs font-semibold text-gray-500">
              Collector
            </span>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => clearSignature("collector")}
                className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
              >
                Clear
              </button>
              <button
                type="button"
                onClick={() => saveSignature("collector")}
                className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-baseColor-primary transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>

         {/* Client Signature */}
        <div className="relative border border-gray-300 rounded-lg p-4 bg-gray-50">
          {/* <h3 className="text-sm font-semibold text-gray-600 mb-2">Client </h3> */}
          <SignatureCanvas
            penColor="black"
            canvasProps={{
              className: "border border-gray-400 w-full h-40 rounded-md",
            }}
            ref={clientSigCanvas}
          />
          <div className="flex justify-between items-center mt-3">
            <span className="text-xs font-semibold text-gray-500">Client</span>
            <div className="flex gap-2">
              <button
                type="button"
                onClick={() => clearSignature("client")}
                className="text-xs text-red-600 hover:bg-red-100 px-3 py-1 rounded-md transition"
              >
                Clear
              </button>
              <button
                type="button"
                onClick={() => saveSignature("client")}
                className="text-xs bg-baseColor-primary text-white px-3 py-1 rounded-md hover:bg-baseColor-primary transition"
              >
                Save
              </button>
            </div>
          </div>
        </div>
      </div>

      {/* Attachments */}
      <div className="w-full mt-8">
        <h3 className="text-sm font-semibold text-gray-600 mb-4">
          Attachments
        </h3>
        <Attachement
          handleChange={handleImageChange}
          disabled={false}
          // preview={files.map((f) => f.preview)}
                    preview={image || ""}

          width="w-full"
          label="Attach"
          multiple={true}
          removeImages={removeImages}
          className="border border-gray-300 rounded-lg p-4 bg-white shadow-sm"
        />
      </div>
    </div>
  );

  return (
    <FormLayout
      searchFun={searchFunction}
      searchValue={valueOfSearch}
      total={totalCount}
    >
      <div className="w-full h-full mt-0.5">
        <div className="w-full h-[calc(100vh-180px)] bg-white rounded-md overflow-hidden px-4 py-2">
          <div className="w-full h-[calc(100vh-235px)]">
              <div className="flex flex-wrap">
              {FormType.map((form) => (
                <button
                  key={form.id}
                  onClick={() => handleTabClick(form.id)}
                  className={`mx-3 mb-2 pb-1 text-xs 2xl:text-sm font-medium ${
                    activeTab === form.id
                      ? "text-baseColor-primary underline underline-offset-4 decoration-2"
                      : "text-gray-500"
                  }`}
                >
                  {form.category}
                </button>
              ))}
            </div>

              
             <div className="w-full max-h-[calc(100vh-235px)] overflow-y-auto py-4"> 
  {NewForm ? (
    <>
      {NewForm.titles?.map((title, titleIndex) => (
        <div key={titleIndex} className="mb-8">
          <h3 className="text-lg font-semibold mb-4 border-b pb-2 text-white bg-baseColor-primary py-3 px-6">
            {title.titleName}
          </h3>
          <div className="grid grid-cols-1 gap-6">
            {title.fields?.map((field, fieldIndex) => (
              <div key={fieldIndex} className="border-b p-4 rounded-lg">
                {giveValue(field)}
              </div>
            ))}
          </div>
        </div>
      ))}

      {renderSignatureAndAttachments()}
    </>
  ) : (
    <div className="flex justify-center items-center h-64">
      <p className="text-gray-500">No form available</p>
    </div>
  )}
</div>

           
          </div>

          {/* Pagination */}
          {/* <div className="w-full h-[40px] pb-4 bg-white">
            <Pagination
              page={page}
              setPage={setPage}
              totalCount={totalCount}
              pageCount={pageCount}
              setPageCount={setPageCount}
            />
          </div> */}
        </div>
      </div>
    </FormLayout>
  );
}

export default FormsIndex;